module.exports = __webpack_public_path__ + "static/media/tint-slash.1cb09027.svg";